import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

/**
 * Gates the staff console.
 * - Not signed in        -> bounce to /admin/login
 * - Signed in, no profile -> account exists but no role assigned yet
 * - adminOnly + not admin -> bounce to the dashboard
 *
 * Note: this is UX-level gating only. The real protection is Row Level
 * Security in Postgres — even a tampered client only sees what its role allows.
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, profile, role, loading } = useAuth();

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!profile) {
    return (
      <div className="admin-root admin-blank">
        <div className="admin-blank-card">
          <h2>Account not activated</h2>
          <p>
            Your login exists but hasn't been assigned a role yet. Ask an
            administrator to set you up.
          </p>
        </div>
      </div>
    );
  }

  if (adminOnly && role !== 'admin') {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
